"use strict";

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["frameToDisplay", "style", "inputProps", "compositionHeight", "compositionWidth", "durationInFrames", "fps", "className", "errorFallback", "renderLoading"];

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Thumbnail = exports.ThumbnailFn = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var remotion_1 = require("remotion");

var emitter_context_1 = require("./emitter-context");

var event_emitter_1 = require("./event-emitter");

var SharedPlayerContext_1 = require("./SharedPlayerContext");

var ThumbnailUI_1 = __importDefault(require("./ThumbnailUI"));

var ThumbnailFn = function ThumbnailFn(_ref, ref) {
  var frameToDisplay = _ref.frameToDisplay,
      style = _ref.style,
      inputProps = _ref.inputProps,
      compositionHeight = _ref.compositionHeight,
      compositionWidth = _ref.compositionWidth,
      durationInFrames = _ref.durationInFrames,
      fps = _ref.fps,
      className = _ref.className,
      _ref$errorFallback = _ref.errorFallback,
      errorFallback = _ref$errorFallback === void 0 ? function () {
    return '⚠️';
  } : _ref$errorFallback,
      renderLoading = _ref.renderLoading,
      componentProps = _objectWithoutProperties(_ref, _excluded);

  var _ref2 = (0, react_1.useState)(function () {
    return String((0, remotion_1.random)(null));
  }),
      _ref3 = _slicedToArray(_ref2, 1),
      thumbnailId = _ref3[0];

  var rootRef = (0, react_1.useRef)(null);
  var timelineState = (0, react_1.useMemo)(function () {
    return {
      playing: false,
      frame: frameToDisplay,
      rootId: thumbnailId,
      imperativePlaying: {
        current: false
      },
      playbackRate: 1,
      setPlaybackRate: function setPlaybackRate() {
        throw new Error('thumbnail');
      },
      audioAndVideoTags: {
        current: []
      }
    };
  }, [frameToDisplay, thumbnailId]);
  (0, react_1.useImperativeHandle)(ref, function () {
    return rootRef.current;
  }, []);
  var Component = remotion_1.Internals.useLazyComponent(componentProps);

  var _ref4 = (0, react_1.useState)(function () {
    return new event_emitter_1.ThumbnailEmitter();
  }),
      _ref5 = _slicedToArray(_ref4, 1),
      emitter = _ref5[0];

  var passedInputProps = (0, react_1.useMemo)(function () {
    return inputProps !== null && inputProps !== void 0 ? inputProps : {};
  }, [inputProps]);
  return (0, jsx_runtime_1.jsx)(SharedPlayerContext_1.SharedPlayerContexts, {
    timelineContext: timelineState,
    component: Component,
    compositionHeight: compositionHeight,
    compositionWidth: compositionWidth,
    durationInFrames: durationInFrames,
    fps: fps,
    inputProps: inputProps,
    numberOfSharedAudioTags: 0,
    children: (0, jsx_runtime_1.jsx)(emitter_context_1.ThumbnailEmitterContext.Provider, {
      value: emitter,
      children: (0, jsx_runtime_1.jsx)(ThumbnailUI_1.default, {
        className: className,
        errorFallback: errorFallback,
        inputProps: passedInputProps,
        renderLoading: renderLoading,
        style: style
      })
    })
  });
};

exports.ThumbnailFn = ThumbnailFn;
exports.Thumbnail = (0, react_1.forwardRef)(exports.ThumbnailFn);